// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.account-deletion {
  margin-top: 16px;
}

.account-deletion-desc {
  color: var(--text-secondary);
  margin-bottom: 24px;
  line-height: 1.6;
}

.account-deletion-form {
  display: flex;
  flex-direction: column;
  gap: 20px;
  max-width: 400px;
}

.account-deletion-field {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.account-deletion-field label {
  font-weight: 600;
  color: var(--text-primary);
  font-size: 0.95rem;
}

.account-deletion-field input {
  padding: 12px 16px;
  border: 1px solid var(--border-card);
  border-radius: 8px;
  font-size: 1rem;
  background: var(--bg-main);
  color: var(--text-primary);
  transition: border-color 0.2s, box-shadow 0.2s;
}

.account-deletion-field input:focus {
  outline: none;
  border-color: var(--color-primary);
  box-shadow: 0 0 0 3px rgba(38, 28, 193, 0.15);
}

.account-deletion-field input::placeholder {
  color: var(--text-muted);
}

.account-deletion-field input:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.account-deletion-otp-info {
  color: var(--text-secondary);
  font-size: 0.9rem;
  margin: 0 0 8px 0;
}

.account-deletion-error {
  color: #dc3545;
  font-size: 0.9rem;
  margin: 0;
}

.account-deletion-actions {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}

.account-deletion-btn {
  padding: 12px 24px;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  border: none;
  transition: opacity 0.2s, transform 0.1s;
}

.account-deletion-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.account-deletion-btn:not(:disabled):hover {
  transform: translateY(-1px);
}

.account-deletion-btn--primary {
  background: var(--color-primary);
  color: white;
}

.account-deletion-btn--primary:hover:not(:disabled) {
  background: var(--color-primary-dark);
}

.account-deletion-btn--danger {
  background: #dc3545;
  color: white;
}

.account-deletion-btn--danger:hover:not(:disabled) {
  background: #c82333;
}

.account-deletion-btn--secondary {
  background: var(--bg-cta);
  color: var(--color-primary);
}

.account-deletion-btn--secondary:hover:not(:disabled) {
  background: rgba(58, 154, 255, 0.2);
}

.account-deletion-success {
  text-align: center;
  padding: 32px 0;
}

.account-deletion-success-icon {
  width: 64px;
  height: 64px;
  margin: 0 auto 24px;
  background: #28a745;
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 2rem;
  font-weight: bold;
}

.account-deletion-success-message {
  font-size: 1.1rem;
  color: var(--text-primary);
  margin-bottom: 24px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/AccountDeletion.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,oCAAoC;EACpC,kBAAkB;EAClB,eAAe;EACf,0BAA0B;EAC1B,0BAA0B;EAC1B,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,6CAA6C;AAC/C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;EAC5B,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,wCAAwC;AAC1C;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,0BAA0B;EAC1B,mBAAmB;AACrB","sourcesContent":[".account-deletion {\n  margin-top: 16px;\n}\n\n.account-deletion-desc {\n  color: var(--text-secondary);\n  margin-bottom: 24px;\n  line-height: 1.6;\n}\n\n.account-deletion-form {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  max-width: 400px;\n}\n\n.account-deletion-field {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.account-deletion-field label {\n  font-weight: 600;\n  color: var(--text-primary);\n  font-size: 0.95rem;\n}\n\n.account-deletion-field input {\n  padding: 12px 16px;\n  border: 1px solid var(--border-card);\n  border-radius: 8px;\n  font-size: 1rem;\n  background: var(--bg-main);\n  color: var(--text-primary);\n  transition: border-color 0.2s, box-shadow 0.2s;\n}\n\n.account-deletion-field input:focus {\n  outline: none;\n  border-color: var(--color-primary);\n  box-shadow: 0 0 0 3px rgba(38, 28, 193, 0.15);\n}\n\n.account-deletion-field input::placeholder {\n  color: var(--text-muted);\n}\n\n.account-deletion-field input:disabled {\n  opacity: 0.7;\n  cursor: not-allowed;\n}\n\n.account-deletion-otp-info {\n  color: var(--text-secondary);\n  font-size: 0.9rem;\n  margin: 0 0 8px 0;\n}\n\n.account-deletion-error {\n  color: #dc3545;\n  font-size: 0.9rem;\n  margin: 0;\n}\n\n.account-deletion-actions {\n  display: flex;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.account-deletion-btn {\n  padding: 12px 24px;\n  border-radius: 8px;\n  font-size: 1rem;\n  font-weight: 600;\n  cursor: pointer;\n  border: none;\n  transition: opacity 0.2s, transform 0.1s;\n}\n\n.account-deletion-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.account-deletion-btn:not(:disabled):hover {\n  transform: translateY(-1px);\n}\n\n.account-deletion-btn--primary {\n  background: var(--color-primary);\n  color: white;\n}\n\n.account-deletion-btn--primary:hover:not(:disabled) {\n  background: var(--color-primary-dark);\n}\n\n.account-deletion-btn--danger {\n  background: #dc3545;\n  color: white;\n}\n\n.account-deletion-btn--danger:hover:not(:disabled) {\n  background: #c82333;\n}\n\n.account-deletion-btn--secondary {\n  background: var(--bg-cta);\n  color: var(--color-primary);\n}\n\n.account-deletion-btn--secondary:hover:not(:disabled) {\n  background: rgba(58, 154, 255, 0.2);\n}\n\n.account-deletion-success {\n  text-align: center;\n  padding: 32px 0;\n}\n\n.account-deletion-success-icon {\n  width: 64px;\n  height: 64px;\n  margin: 0 auto 24px;\n  background: #28a745;\n  color: white;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 2rem;\n  font-weight: bold;\n}\n\n.account-deletion-success-message {\n  font-size: 1.1rem;\n  color: var(--text-primary);\n  margin-bottom: 24px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
